import { getIn } from 'formik'

export const getErrorMessage = ({ errors, name, touched }) => {
  const error = getIn(errors, name)
  const touch = getIn(touched, name)
  return name && touch && error ? error : null
}
